import React, { useState, useEffect } from 'react'
import moment from 'moment'

import { newFetch, GET, POST } from '../../../helpers/fetch'

import { config } from '../../../config'

const { SERVER_URL } = config

const CartDetail = ({
  history,
  match: {
    params: { cart_id }
  }
}) => {
  const [cart, setCart] = useState(null)

  const fetchCart = async () => {
    let api_path = `/reward/cart/${cart_id}`
    let response = await newFetch(GET, api_path)

    response.success && setCart(response.data)
  }

  useEffect(() => {
    fetchCart()
  }, [])

  return (
    <div className="container pt-4 d-flex flex-column">
      <div></div>
    </div>
  )
}

export default CartDetail
